import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from "@material-ui/core/Button";
import axios from "axios";

export const ContactForm = () => {
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [mensagem, setMensagem] = useState("");

  const handleSubmit = e => {
    e.preventDefault();
    console.log(nome);
    console.log(telefone);
    console.log(email);
    console.log(mensagem);
    const data = {
      name: nome,
      email,
      phone: telefone,
      msg: mensagem
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    };
    // axios
    //   .post("/img/enviar.php", data)
    //   .then(res => {
    //     alert("Enviado com sucesso!");
    //     console.log(res);
    //   })
    //   .catch(err => console.log("err", err));
    axios
      .post("/img/enviar.php", data, config)
      .then(res => {
        alert("Enviado com sucesso!");
        console.log(res);
      })
      .catch(err => console.log("err", err));
  };

  return (
    <div
      style={{
        width: "50%",
        display: "flex",
        flexDirection: "column",
        padding: "50px"
      }}
    >
      <h2 style={{ textAlign: "center" }}>FORMULÁRIO PARA CONTATO</h2>
      <form onSubmit={handleSubmit} noValidate autoComplete="off">
        <div style={{ display: "flex" }}>
          <TextField
            fullWidth={true}
            id="name"
            label="Nome"
            variant="outlined"
            style={{ margin: "0 15px 15px 0" }}
            value={nome}
            onChange={e => setNome(e.target.value)}
          />
          <TextField
            fullWidth={true}
            id="phone"
            label="Telefone"
            variant="outlined"
            value={telefone}
            onChange={e => setTelefone(e.target.value)}
          />
        </div>
        <div style={{ width: "100%" }}>
          <TextField
            fullWidth={true}
            type={"email"}
            id="outlined-basic"
            label="Email"
            variant="outlined"
            style={{ marginBottom: "20px" }}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div style={{ width: "100%" }}>
          <TextField
            id={"msg"}
            fullWidth={true}
            placeholder="MultiLine with rows: 2 and rowsMax: 4"
            multiline
            rows={2}
            rowsMax={4}
            label="Mensagem"
            variant="outlined"
            value={mensagem}
            onChange={e => setMensagem(e.target.value)}
          />
        </div>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            marginTop: "20px"
          }}
        >
          <Button onClick={handleSubmit} variant="contained" color="primary">
            ENVIAR
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
